export const validateUrl = (url?: string, message?: string) => {
  const errorMessage = message || 'Issuer URL needs to be a valid URL';
  if (!url?.length) {
    return true;
  }
  try {
    const urlObject = new URL(url);
    if (urlObject.protocol !== 'https:') {
      return errorMessage;
    }
    return true;
  } catch (e) {
    return errorMessage;
  }
};

const DOMAIN_REGEX =
  /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*\.[a-z]{2,63}$/i;

export const validateEmailDomains = (domains?: string) => {
  if (!domains?.length) {
    return true;
  }
  const isValid = domains.split(';').every((domain) => DOMAIN_REGEX.test(domain.trim()));
  return isValid || 'Email Domains must be valid domains separated by semicolons';
};
